import token, { tokenToVars } from '../token';
import Message from './message';

export { Message };
export default tokenToVars(Message, token);
